<template>
  <div class="FAQList__container">
    <FormFilter
      :config="{ ...config, listCategory: getListCategory() }"
      @filtered="displayResults"
      @has-results="displayPagination"
      :allowReset="true"
      @loadingChange="setFormFilterLoading"
      :allowOnlyInitialIds="true"
    />
    <Accordion
      v-if="!formFilterLoading && displayedResults && displayedResults.length"
      :itemCollection="displayedResults"
      :initialOpenAccordionItems="
        this.anchorLink ? [getInitialOpenAccordionItemId()] : null
      "
      :multipleActive="true"
      ref="accordion"
    >
      <template v-slot:title="itemProps">
        <div
          :id="createFaqElementId(itemProps.accordionItem.id)"
          v-html="itemProps.accordionItem.question"
        ></div>
      </template>
      <template v-slot:content="itemProps">
        <div v-html="itemProps.accordionItem.answer"></div>
      </template>
    </Accordion>
    <Pagination
      v-show="
        (config.loadInitialData || hasResults) &&
          config.pagination.resultsPerPage < fullAmountOfResults
      "
      :config="config.pagination"
      :results="results.length"
      @update="displayPaginatedResults"
    />
    <Modal
      :isModalOpen="videoUrl !== null"
      :isVideo="true"
      @closeModal="videoUrl = null"
    >
      <iframe
        v-if="videoUrl !== null"
        :src="videoUrl"
        frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </Modal>
  </div>
</template>

<script>
import FormFilter from "../FormFilter/FormFilter";
import Accordion from "../Accordion/Accordion";
import Pagination from "../Pagination/Pagination";
import Modal from "../Modal/Modal";
import { ListCategory } from "../../globals/constants/formFilter";

export default {
  name: "FAQList",
  components: {
    FormFilter,
    Accordion,
    Modal,
    Pagination
  },
  props: {
    config: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      anchorLink: null,
      results: [],
      displayRange: [0, 11],
      displayedResults: [],
      hasResults: false,
      formFilterLoading: false,
      fullAmountOfResults: 999999,
      videoUrl: null
    };
  },
  methods: {
    showFaqVideoModal(e) {
      const { target } = e;

      if (target && target.classList.contains("faqVideoLink")) {
        e.preventDefault();
        this.videoUrl = target.getAttribute("href");
      }
    },
    setFormFilterLoading(isLoading) {
      this.formFilterLoading = isLoading;
    },
    displayPagination(hasResults) {
      this.hasResults = hasResults;
    },
    displayResults(results, preventResetAccordion) {
      if (!preventResetAccordion) {
        this.resetAccordion();
      }
      this.results = results;
      this.displayedResults = [];
      for (let i = 0; i < this.results.length; i++) {
        if (i >= this.displayRange[0] && i <= this.displayRange[1]) {
          this.displayedResults.push(this.results[i]);
        } else if (i > this.displayRange[1]) {
          break;
        }
      }
    },
    resetAccordion() {
      this.$refs.accordion && this.$refs.accordion.reset();
    },
    displayPaginatedResults(displayRange) {
      this.displayRange = displayRange;
      this.displayResults(this.results, true);
    },
    createFaqElementId(id) {
      return `faq${id}`;
    },
    getListCategory() {
      return ListCategory.FAQ;
    },
    modifyConfigIfAnchorLink() {
      this.config.pagination.resultsSelect.initialSelectOption = this.config.pagination.resultsSelect.selectOptions[
        this.config.pagination.resultsSelect.selectOptions.length - 1
      ];
      this.config.pagination.resultsPerPage = this.fullAmountOfResults;
      this.config.loadInitialData = true;
      this.displayRange = [0, this.fullAmountOfResults];
    },
    scrollToFaqItem() {
      const element = this.$el.querySelector(this.anchorLink);
      if (element) {
        const duration = 1500;
        const pageHeader =
          document.getElementsByClassName("PageHeader__navMain")[0] ||
          document.getElementsByClassName("PageHeader__sticky")[0];
        const moreSpace = 40;
        const options = {
          offset: pageHeader ? -(pageHeader.scrollHeight + moreSpace) : 0
        };
        this.$scrollTo(element, duration, options);
        this.anchorLink = null;
      }
    },
    getInitialOpenAccordionItemId() {
      const items = this.displayedResults.filter(
        item => item.id === parseInt(this.anchorLink.replace(/#faq/, ""), 10)
      );
      if (items.length === 1) {
        return items[0].id;
      }
    }
  },
  updated() {
    if (this.anchorLink) {
      this.scrollToFaqItem();
    }
  },
  unmounted() {
    document.removeEventListener("click", this.showFaqVideoModal);
  },
  created() {
    this.anchorLink = location.hash;
    document.addEventListener("click", this.showFaqVideoModal);

    /**
     * check if there is an anchor link and it starts with a "#faq",
     * if there is an anchor link and it starts not with "#faq" show an error.
     */
    if ((this.anchorLink + "").startsWith("#faq")) {
      this.modifyConfigIfAnchorLink();
    } else if (this.anchorLink && !(this.anchorLink + "").startsWith("#faq")) {
      console.error(
        "This is not a valid FAQ anchor link (hash in URL). The FAQ anchor link should start with '#faq'."
      );
      this.anchorLink = null;
    }
  }
};
</script>
